// extracted by mini-css-extract-plugin
export default {"image":"OrderNotFoundScreen_image__ez1Dy","body":"OrderNotFoundScreen_body__a-uxy","title":"OrderNotFoundScreen_title__42IrL"};